import csstype.*
import csstype.FontFamily.Companion.sansSerif
import emotion.css.CSSStyleSheet
import emotion.css.css
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.css.CSS
import react.create
import react.dom.client.createRoot
import react.useState

fun main() {

    val container = document.createElement("div")
    document.body!!.appendChild(container)
    document.body!!.style.background = rgb(28,27,31).toString()
    container.className = "babaRoot"

    val welcome = Welcome.create {
        name = "Kotlin/JS"
        time= 0
        onGoing = false
    }
    createRoot(container).render(welcome)
}